import { Button, Popup } from 'next-common-lib';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import * as confirmActions from 'redux/ducks/common/confirmDucks';
import i18n from 'i18n';

export const Confirm = () => {
  const dispatch = useDispatch();
  const confirm = useSelector(state => state.confirm);

  const mappingMessage = () => {
    const result = [];
    confirm.message.forEach(msg => {
      result.push(<Trans i18nKey={i18n.t(msg)} />);
    });
    return result;
  };

  return (
    <>
      {confirm.isShow && (
        <Popup
          id="employee_Confirm"
          isShow={confirm.isShow}
          isDimed={confirm.isShow}
          dimedClassName="has-bg"
          size="xs"
          componentType="normalPopup"
          closeFunction={() => {
            dispatch(confirmActions.close());
          }}
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {i18n.t('EM_T_NOTICE')}
            </h1>,
          ]}
          contentsComponent={mappingMessage()}
          bottomComponent={[
            <div className="btn-set al-right">
              <div className="btn-group">
                <Button
                  componentType="solid"
                  className="secondary"
                  size="md"
                  label={i18n.t('EM_T_CANCEL')}
                  onClick={() => {
                    confirm.cancelCallback();
                    dispatch(confirmActions.close());
                  }}
                />
                <Button
                  componentType="solid"
                  className="primary"
                  size="md"
                  label={i18n.t('EM_T_OK')}
                  onClick={() => {
                    confirm.callback();
                    dispatch(confirmActions.close());
                  }}
                />
              </div>
            </div>,
          ]}
        />
      )}
    </>
  );
};
Confirm.propTypes = {};
Confirm.defaultProps = {};
export default Confirm;
